import React from 'react';
import { copy, stats } from '../data/noklar';
export function StatsBar() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100" data-id="element-286" data-mp="1tarjq9bipqkw">
      <div className="mx-auto max-w-6xl px-8 py-14 sm:px-14 lg:flex lg:items-center lg:gap-12" data-id="element-287" data-mp="1t8du4fzlx6kq">
        <h2 className="shrink-0 font-serif text-2xl italic leading-tight text-red-700 lg:w-44" data-id="element-288" data-mp="1odhxt3nc7x1t">
          {copy.stats.title}
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:mt-0 lg:flex-1 lg:grid-cols-5" data-id="element-289" data-mp="1edr4346lpm2s">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse border-l border-slate-900/15 pl-5" data-id="element-290" data-mp="19lpll0iuaz4b">
              <dt className="mt-3 text-sm leading-snug text-slate-900/70" data-id="element-291" data-mp="15lfchezr3sl8">{stat.label}</dt>
              <dd className="font-serif text-6xl leading-none tracking-tight text-slate-900" data-id="element-292" data-mp="10n41v21mte1y">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}